import { toast } from 'react-toastify';
import { object, string, array } from 'yup';

import { isEmpty, getPluralPhrase, isPlural } from '../../../utils';

import {
  testEmail,
  testConfirmEmail,
  testTsAndCs,
} from '../../../validationUtils';

const getSchema = (
  type: string,
  isCheckConfirm?: boolean,
  requiredShotsNum?: number,
) => {
  const emailSchema = object({
    email: testEmail(),
    confirmEmail: isCheckConfirm ? testConfirmEmail() : string().notRequired(),
    isTsAndCs: testTsAndCs(),
  });

  const detailsSchema = object({
    name: string().required('First name is required'),
  });

  const videosSchema = object({
    videoFiles: array().test({
      name: 'test-ugc',
      test(value, ctx) {
        const diff = (requiredShotsNum ?? 0) - (value?.length ?? 0);

        if (diff > 0)
          return ctx.createError({
            message: `${getPluralPhrase(diff, 'video', 'more')} ${isPlural(diff) ? 'are' : 'is'} required`,
          });
        return true;
      },
    }),
  });

  switch (type) {
    case 'details':
      return detailsSchema;
    case 'video':
      return videosSchema;
    case 'email':
    default:
      return emailSchema;
  }
};

export const validateForm = async ({
  type,
  formData,
  isCheckConfirm,
  requiredShotsNum,
}: {
  type: string;
  formData: {};
  isCheckConfirm?: boolean;
  requiredShotsNum?: number;
}) => {
  const errors: { [key: string]: string } = {};

  const schema = getSchema(type, isCheckConfirm, requiredShotsNum);

  await schema.validate(formData, { abortEarly: false }).catch((err) => {
    err.inner.forEach((error: any) => {
      errors[error.path] = error.errors[0];
    });
  });

  if (!isEmpty(errors)) toast.error('Some data is missing or invalid');

  return errors;
};
